import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import CancelButton from '../atoms/CancelButton';
import ConfirmButton from '../atoms/ConfirmButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    openChangeNonUse,
    updateOpenChangeNonUse,
    cancelAction,
    changeAction,
    firstMenuName,
    firstPrice,
    firstCouponCount,
    menuNameChange,
    includedTaxPriceChange,
    quantity
  }) => {
    return (
      <Dialog
        open={openChangeNonUse}
        onClose={() => {
          updateOpenChangeNonUse(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {includedTaxPriceChange * quantity ===
          firstPrice * firstCouponCount ? (
            <DialogContentText id="alert-dialog-description">
              {`・現在のチケット：${firstMenuName} ${firstCouponCount}枚ｘ${firstPrice}円=${firstCouponCount *
                firstPrice}円（税込）`}
              <br />
              {`・分割したいチケット：${menuNameChange} ${quantity}枚ｘ${includedTaxPriceChange}円=${quantity *
                includedTaxPriceChange}円（税込）`}
              <br />
              <br />
              {`本当に分割したいですか。`}
            </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {`・現在のチケット：${firstMenuName} ${firstCouponCount}枚ｘ${firstPrice}円=${firstCouponCount *
                firstPrice}円（税込）`}
              <br />
              {`・分割したいチケット：${menuNameChange} ${quantity}枚ｘ${includedTaxPriceChange}円=${quantity *
                includedTaxPriceChange}円（税込）`}
              <br />
              <br />
              {`編集前と編集後の合計価格が違っています。本当に分割したいですか。`}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <ConfirmButton onClickAction={changeAction} />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
